<ng-template #defaultSearchResultsTemplate let-r="result" let-t="term">
  @if (r.name) {
    @if (r.name !== '-') {
      <div class="d-flex input-group-material-liste-item align-items-center" data-zid="search-result-container-item">
        <div class="flex-grow pr-2 pr-sm-1 mr-2 mr-sm-0 overflow-hidden ellipsis">
          <div class="font-bold">{{ r.name }}</div>
          <ng-container *ngTemplateOutlet="symbol; context: { item: r }" />
        </div>

        <div class="trade info search cursor-pointer" [title]="'asset-search.details-title' | transloco" (click)="showDetails(r.isin)">
          <svg class="icon icon-16">
            <use xlink:href="/assets/img/svgs/svgset.svg#chart" />
          </svg>
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="noData" />
    }
  }
  <ng-container *ngTemplateOutlet="headerRow; context: { headline: r.headline }" />
</ng-template>
<ng-template #headerSearchResultsTemplate let-r="result" let-t="term">
  @if (r.name) {
    @if (r.name !== '-') {
      <div
        class="d-flex input-group-material-liste-item align-items-center"
        data-zid="search-result-container-item"
        [attr.data-isin]="r.isin"
      >
        <div class="flex-grow pr-2 pr-sm-1 mr-2 mr-sm-0 overflow-hidden ellipsis" (click)="showDetails(r.isin)">
          <div class="zero-text default p-small-bold">{{ r.name }}</div>
          <ng-container *ngTemplateOutlet="symbol; context: { item: r }" />
        </div>

        <div
          class="trade buy small cursor-pointer"
          [routerLink]="commonRoutes.postlogin.buyAndSell"
          [queryParams]="{ isin: r.isin, direction: 'buy' }"
        >
          K
        </div>
        <div
          class="trade sell small cursor-pointer"
          [routerLink]="commonRoutes.postlogin.buyAndSell"
          [queryParams]="{ isin: r.isin, direction: 'sell' }"
        >
          V
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="noData" />
    }
  }
  <ng-container *ngTemplateOutlet="headerRow; context: { headline: r.headline }" />
</ng-template>
<ng-template #multiOrderSearchResultsTemplate let-r="result" let-t="term">
  @if (r.name) {
    @if (r.name !== '-') {
      <button
        class="d-flex input-group-material-liste-item align-items-center pr-0"
        [disabled]="r.cat === 'KRYPTO'"
        data-zid="search-result-container-item"
      >
        <div class="row w-100 align-items-center">
          <div class="col">
            <div class="flex-grow pr-2 pr-sm-1 mr-2 mr-sm-0 overflow-hidden ellipsis">
              <div class="font-bold text-wrap">{{ r.name }}</div>
              <ng-container *ngTemplateOutlet="symbol; context: { item: r }" />
            </div>
          </div>
          <div class="col-2 text-right">
            @if (r.isin | hasMultiOrderInstrument: chosenAssets : 'buy') {
              <svg class="icon icon-18">
                <use xlink:href="/assets/img/svgs/svgset.svg#check" />
              </svg>
            } @else {
              <svg class="icon icon-18">
                <use xlink:href="/assets/img/svgs/svgset.svg#add" />
              </svg>
            }
          </div>
        </div>
      </button>
    } @else {
      <ng-container *ngTemplateOutlet="noData" />
    }
  }
  <ng-container *ngTemplateOutlet="headerRow; context: { headline: r.headline }" />
  @if (r.headline === 'Kryptos') {
    <div class="disallowed-hint text-wrap">{{ 'trade.multi-order.positions.disallowed-hint' | transloco }}</div>
  }
</ng-template>
<ng-template #multiSavingsPlanSearchResultsTemplate let-r="result" let-t="term">
  @if (r.name) {
    @if (r.name !== '-') {
      <button class="d-flex input-group-material-liste-item align-items-center pr-0" data-zid="search-result-container-item">
        <div class="row w-100 align-items-center">
          <div class="col">
            <div class="flex-grow pr-2 pr-sm-1 mr-2 mr-sm-0 overflow-hidden ellipsis">
              <div class="font-bold text-wrap">{{ r.name }}</div>
              <ng-container *ngTemplateOutlet="symbol; context: { item: r }" />
            </div>
          </div>
          <div class="col-2 text-right">
            @if (r.isin | hasAsset: chosenAssets) {
              <svg class="icon icon-18">
                <use xlink:href="/assets/img/svgs/svgset.svg#check" />
              </svg>
            } @else {
              <svg class="icon icon-18">
                <use xlink:href="/assets/img/svgs/svgset.svg#add" />
              </svg>
            }
          </div>
        </div>
      </button>
    } @else {
      <ng-container *ngTemplateOutlet="noData" />
    }
  }
  <ng-container *ngTemplateOutlet="headerRow; context: { headline: r.headline }" />
  @if (r.headline === 'Kryptos') {
    <div class="disallowed-hint text-wrap">{{ 'trade.multi-order.positions.disallowed-hint' | transloco }}</div>
  }
</ng-template>
<ng-template #savingsPlanOnboardingSearchResultsTemplate let-r="result" let-t="term">
  @if (r.name) {
    @if (r.name !== '-' && r.cat !== 'KRYPTO') {
      <div class="d-flex input-group-material-liste-item align-items-center" data-zid="search-result-container-item">
        <div class="flex-grow pr-2 pr-sm-1 mr-2 mr-sm-0 overflow-hidden ellipsis">
          <div class="font-bold">{{ r.name }}</div>
          <ng-container *ngTemplateOutlet="symbol; context: { item: r }" />
        </div>

        <div class="trade info search cursor-pointer" [title]="'asset-search.details-title' | transloco" (click)="showDetails(r.isin)">
          <svg class="icon icon-16">
            <use xlink:href="/assets/img/svgs/svgset.svg#chart" />
          </svg>
        </div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="noData" />
    }
  }
  <ng-container *ngTemplateOutlet="headerRow; context: { headline: r.headline }" />
</ng-template>

<ng-template #loadingInstrument>
  <div class="d-flex input-group-material-liste-item autocompletionempty" (click)="preventSelection($event)">
    <div class="flex-grow text-color-primary">{{ 'asset-search.loading' | transloco }}</div>
  </div>
</ng-template>
<ng-template #headerRow let-headline="headline">
  @if (headline) {
    <div class="d-flex input-group-material-liste-headline autocompletionheadline font-medium" (click)="preventSelection($event)">
      {{ headline }}
    </div>
  }
</ng-template>
<ng-template #noData>
  <div class="d-flex input-group-material-liste-item autocompletionempty" data-zid="search-result-empty" (click)="preventSelection($event)">
    <div class="flex-grow">
      {{ 'asset-search.no-data' | transloco }}
    </div>
  </div>
</ng-template>
<ng-template #symbol let-item="item">
  <div class="zero-text default p-xsmall-reg">
    @if (item.cat !== 'KRYPTO') {
      {{ item.isin }}
      @if (item.wkn) {
        / {{ item.wkn }}
      }
    } @else {
      {{ item.shortName }}
    }
  </div>
</ng-template>

@switch (type) {
  @case ('header') {
    <div class="header-search-input-container">
      <input
        type="text"
        spellcheck="false"
        class="asset-search-input asset-search-header"
        data-zid="navigation-search-input"
        [(ngModel)]="model"
        [ngbTypeahead]="search"
        [resultTemplate]="headerSearchResultsTemplate"
        [inputFormatter]="formatter"
        [placeholder]="'asset-search.header.label' | transloco"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        [class.empty]="!searchInput.value"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
      />
      <div class="input-group-material-icon">
        <svg class="icon mirror icon-24 text-color-grey">
          <use xlink:href="/assets/img/svgs/svgset.svg#search" />
        </svg>
      </div>
    </div>
  }
  @case ('watchlist') {
    <div
      class="input-group-material input-group-right keepcolor"
      [ngClass]="{
        'input-group-material--light input-group-material-small padding-xs-bottom-15': isSmall,
      }"
    >
      <input
        type="text"
        spellcheck="false"
        class="asset-search-input asset-search-header"
        data-zid="watchlist-search-input"
        [(ngModel)]="model"
        [ngbTypeahead]="search"
        [resultTemplate]="defaultSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        [class.empty]="!searchInput.value"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
        [placeholder]="'asset-search.watchlist.label' | transloco"
      />
      <div class="input-group-material-icon" [ngClass]="{ 'text-color-basic': !isSmall }">
        <svg class="icon mirror">
          <use xlink:href="/assets/img/svgs/svgset.svg#search" />
        </svg>
      </div>
    </div>
  }
  @case ('savings-plan') {
    <div class="input-group-material input-group-right keepcolor">
      <div class="input-group-material-icon text-color-basic">
        <svg class="icon mirror">
          <use xlink:href="/assets/img/svgs/svgset.svg#search" />
        </svg>
      </div>
      <input
        id="typeahead-template"
        class="w-100"
        type="text"
        spellcheck="false"
        data-zid="savingsplan-search-input"
        [placeholder]="'asset-search.savings-plan.label' | transloco"
        [(ngModel)]="model"
        [ngbTypeahead]="savingsPlansSearch"
        [resultTemplate]="defaultSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
      />
    </div>
  }
  @case ('savings-plan-create-form') {
    <div class="input-group-material input-group-right keepcolor">
      <input
        id="typeahead-template"
        class="w-100"
        type="text"
        spellcheck="false"
        autofocus
        [placeholder]="'asset-search.savings-plan.label' | transloco"
        [(ngModel)]="model"
        [ngbTypeahead]="savingsPlansSearch"
        [resultTemplate]="defaultSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
      />
    </div>
  }
  @case ('savings-plan-onboarding') {
    <div class="input-group-material input-group-right keepcolor">
      <input
        id="typeahead-template"
        class="w-100"
        type="text"
        spellcheck="false"
        autofocus
        [placeholder]="'asset-search.savings-plan.label' | transloco"
        [(ngModel)]="model"
        [ngbTypeahead]="savingsPlansSearch"
        [resultTemplate]="savingsPlanOnboardingSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
      />
    </div>
  }
  @case ('savings-plan-modal') {
    <div class="input-group-material asset-search-multi-order input-group-right keepcolor">
      <input
        id="typeahead-template"
        class="w-100"
        type="text"
        spellcheck="false"
        autofocus
        [placeholder]="'asset-search.savings-plan.label' | transloco"
        [(ngModel)]="model"
        [ngbTypeahead]="savingsPlansSearch"
        [resultTemplate]="multiSavingsPlanSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
      />
    </div>
  }
  @case ('underlying') {
    <div class="input-group-material padding-bottom-15 keepcolor">
      <div class="input-group-material-icon text-color-basic">
        <svg class="icon">
          <use xlink:href="/assets/img/svgs/svgset.svg#search" />
        </svg>
      </div>
      <input
        id="typeahead-template"
        type="text"
        spellcheck="false"
        autofocus
        [placeholder]="'asset-search.underlying.label' | transloco"
        [(ngModel)]="model"
        [ngbTypeahead]="underlyingSearch"
        [resultTemplate]="defaultSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
      />
    </div>
  }
  @case ('multi-order') {
    <div class="input-group-material asset-search-multi-order input-group-right keepcolor">
      <input
        id="typeahead-template"
        type="text"
        required="required"
        spellcheck="false"
        [attr.tabindex]="isDisabled ? -1 : null"
        [attr.autofocus]="!isDisabled"
        [(ngModel)]="model"
        [ngbTypeahead]="search"
        [resultTemplate]="multiOrderSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="$event.item.cat !== 'KRYPTO' && itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        [class.empty]="!searchInput.value"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
        data-zid="asset-search-input"
        [placeholder]="'asset-search.default.label' | transloco"
      />
    </div>
  }
  @default {
    <div class="input-group-material asset-search-default input-group-right padding-bottom-15">
      @if (!searchInput.value) {
        <div class="input-group-material-icon text-color-basic">
          <svg class="icon mirror" viewBox="0 0 128 128">
            <circle stroke="currentColor" class="seacls-2" cx="74" cy="54" r="47" fill="none" stroke-width="10px" stroke-miterlimit="10" />
            <line
              stroke="currentColor"
              class="seacls-3"
              x1="39"
              y1="89"
              x2="7"
              y2="121"
              fill="none"
              stroke-width="10px"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
          </svg>
        </div>
      }

      <input
        id="typeahead-template"
        type="text"
        required="required"
        spellcheck="false"
        [attr.tabindex]="isDisabled ? -1 : null"
        [attr.autofocus]="!isDisabled"
        [(ngModel)]="model"
        [ngbTypeahead]="search"
        [resultTemplate]="defaultSearchResultsTemplate"
        [inputFormatter]="formatter"
        (selectItem)="itemSelected($event)"
        #searchInput
        (click)="repeatLastInput()"
        [class.empty]="!searchInput.value"
        (focus)="gotFocus()"
        (blur)="handleBlur()"
        data-zid="asset-search-input"
        placeholder="Produktbezeichnung, WKN oder ISIN"
      />
      @if (searchInput.value) {
        <button class="autocompletion-clear close" (click)="clearInput(searchInput)" type="button">
          <svg class="icon icon-14 text-color-basic" viewBox="0 0 128 128">
            <polyline
              stroke="currentColor"
              class="edtcls-2"
              points="73.72 26.14 11.18 88.68 7.01 120.64 39.67 117.17 102.2 54.63"
              fill="none"
              stroke-width="10px"
              stroke-linejoin="round"
            />
            <line
              stroke="currentColor"
              class="edtcls-3"
              x1="87.96"
              y1="40.39"
              x2="26.12"
              y2="102.23"
              fill="none"
              stroke-width="10px"
              stroke-miterlimit="10"
            />
            <line
              stroke="currentColor"
              class="edtcls-4"
              x1="12.22"
              y1="88.33"
              x2="40.01"
              y2="116.13"
              fill="none"
              stroke-width="10px"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              stroke="currentColor"
              class="edtcls-4"
              d="M92.75,14.15H113a10,10,0,0,1,10,10v12.6a0,0,0,0,1,0,0H82.75a0,0,0,0,1,0,0V24.15A10,10,0,0,1,92.75,14.15Z"
              transform="translate(48.13 -65.31) rotate(45)"
              fill="none"
              stroke-width="10px"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
          </svg>
        </button>
      }
    </div>
  }
}
